import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalCard from "../../../../components/GlobalCardComponent";
import CustomCardWithBorder from "../../../../components/CustomCardWithBorder";

export default function SabSubserviceComp({ subserviceCardData }) {
  const [updatedData, setUpdatedData] = useState([]);

  useEffect(() => {
    if (subserviceCardData?.result) {
      const mappedData = subserviceCardData.result.map((item) => {
        let image = "";
      
        switch (item?.name) {
          case "Under Graduate":
            image = "/newdashboard/Group 1171282792 (3).png";

            break;
          case "Post Graduate":
            image = "/newdashboard/Group 1171282793.png";
            break;
          default:
            image = "/newdashboard/Group 1171282793.png";

            break;
        }

        return { ...item, firstImage: image };
      });

      setUpdatedData(mappedData);
    }
  }, [subserviceCardData]);

  //  open details pages
  const handleViewdetails = (data) => {
   
    localStorage.setItem("sapDetails", JSON.stringify(data));
    const url = `/test-prep/sapinfo?test=${encodeURIComponent(data?.name)}`;
    window.open(url, "_blank"); // open in new tab
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} textAlign="center">
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: "27px",
              fontWeight: 500,
              color: "#161719",
            }}
          >
            Choose Your <span style={{ color: "#572575" }}>Pathway</span>
          </Typography>
          <Typography
            mt={1}
            sx={{
              fontFamily: "Inter",
              fontSize: "15px",
              fontWeight: 400,
              color: "#3F424C",
            }}
          >
            Select your education level to explore the right exams, prep
            programs, and guidance tailored for you.
          </Typography>
        </Grid>

        <Grid item xs={12} mt={4}>
          <Grid container spacing={5} justifyContent="center">
            {updatedData?.map((data) => (
              <Grid item xs={12} sm={6} md={4}>
                <CustomCardWithBorder
                boxShadow={true}
                  hovershadowEffect={true}
                  height="100%"
                  onClick={() => handleViewdetails(data)}
                  cursor={true}
                >
                  <Grid
                    container
                    spacing={4}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Box sx={{ width: "50px", height: "50px" }}>
                          <img
                            src={data?.firstImage}
                            alt="img"
                            width="100%"
                            height="100%"
                          />
                        </Box>
                      </Box>
                      <Typography
                        mt={1}
                        textAlign="center"
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "19px",
                         
                          color: "#000000",
                        }}
                      >
                        {data?.name}
                      </Typography>
                      <Typography
                        mt={1}
                        textAlign="center"
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: 400,
                          fontSize: "12px",
                          
                          color: "#5F6570",
                          fontStyle: "normal",
                        }}
                      >
                        {data?.description}
                      </Typography>
                    </Grid>
                  </Grid>
                </CustomCardWithBorder>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
